import { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const STORAGE_KEY = "idea_events_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, quantity, days) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.product_id === product.id);
      if (existing) {
        return prev.map((i) =>
          i.product_id === product.id ? { ...i, quantity, days } : i
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          image: product.image_urls?.[0] || "",
          price_per_day: product.price_per_day,
          quantity,
          days,
        },
      ];
    });
  };

  const updateItem = (productId, patch) =>
    setItems((prev) => prev.map((i) => (i.product_id === productId ? { ...i, ...patch } : i)));

  const removeItem = (productId) =>
    setItems((prev) => prev.filter((i) => i.product_id !== productId));

  const clearCart = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price_per_day * i.quantity * i.days, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, updateItem, removeItem, clearCart, count, subtotal }}
    >
      {children}
    </CartContext.Provider>
  );
};
